import { Box } from '@primer/react';
import { Heading } from '@upright/ui/common/generic/components/primer-custom/heading';
import { Text } from '@upright/ui/common/generic/components/primer-custom/text';

interface Props {
  definition: string | undefined;
}

export const ImpactCategoryDefinition = (props: Props) => {
  if (!props.definition) {
    return <></>;
  }

  return (
    <Box mb={3}>
      <Heading fontSize="micro" sx={{ mb: 2 }}>
        Definition
      </Heading>
      <Text as="p" mb={2}>
        {props.definition}
      </Text>
    </Box>
  );
};
